export default __webpack_public_path__ + "static/media/tab1_2.ffed3651.png";